import http from "@/utils/request";
// 请求首页菜单
export const Sys_lookup = async () => {
    // 返回一个promise对象
    let p = new Promise(function (resolve, reject) {
        http.get("/home/Sys_lookup").then(data =>{
            if(data.success == 0) {
                resolve([]);
                return;
            }
            /*
            // 菜單同步日志使用現有報表權限，後端尚未建立菜單資料時補上前端路由。
            var reportMenu = data.find(t => {
                var label = t.label || '';
                return label === '報表' || label === '報表中心' || label === '报表' || label.indexOf('報表') >= 0 || label.indexOf('报表') >= 0;
            });
            if (reportMenu != null) {
                if (!reportMenu.children) reportMenu.children = [];
                if (!reportMenu.children.some(t => t.name === 'MenuSyncLog')) {
                    reportMenu.children.push({
                        path: 'MenuSyncLog',
                        name: 'MenuSyncLog',
                        label: '同步日志',
                        icon: 'menu',
                        url: 'Report/MenuSyncLog',
                    });
                }
            }*/
            /*
            var baseMenu = data.find(t => t.label === '_base_setup' || t.label === '基本設定' || (t.label && t.label.indexOf('基本') !== -1));
            if (!baseMenu) {
                baseMenu = { path: 'base_setup', name: 'base_setup', label: '_base_setup', icon: 'setting', children: [] };
                data.push(baseMenu);
            }
            if (!baseMenu.children) baseMenu.children = [];
            if (!baseMenu.children.some(t => t.name === 'Wechat_report_manager')) {
                baseMenu.children.push({ path: 'Wechat_report_manager', name: 'Wechat_report_manager',
                    label: '_wechat_report_manager', icon: 'document', url: 'Wechat_report_manager/Index', acode: 'YSAED' });
            }
            if (!baseMenu.children.some(t => t.name === 'Wechat_report_auth')) {
                baseMenu.children.push({
                    path: 'Wechat_report_auth',
                    name: 'Wechat_report_auth',
                    label: '_wechat_report_auth',
                    icon: 'chat-dot-round',
                    url: 'Wechat_report_auth/Index',
                    acode: 'YSAED',
                });
            }
            */
            //增加附屬的Router
            var pMenus = data.filter(t=>t.label == '基本設定');
            if(pMenus.length == 1)
            {
                var cMenus = pMenus[0].children.filter(t=>t.name == 'JobTemplate')
                if(cMenus.length == 1)
                {
                    var menu4 = {
                        path: "JobTemplate_edit",
                        name: "JobTemplate_edit",
                        label: "Job 模板",
                        icon: "s-home",
                        meta: {
                            istrun: true // 默认隐藏路由
                        },
                        url: "Setup_job/Template_edit",
                    };
                    data.push(menu4);
                }
                cMenus = pMenus[0].children.filter(t=>t.name == 'JobTutorial')
                if(cMenus.length == 1)
                {
                    var menu5 = {
                        path: "JobTutorial_edit",
                        name: "JobTutorial_edit",
                        label: "Job 教程",
                        icon: "s-home",
                        meta: {
                            istrun: true // 默认隐藏路由
                        },
                        url: "JobTutorial/JobTutorial_edit",
                    };
                    data.push(menu5);
                }
            }
            pMenus = data.filter(t=>t.label == '維修');
            if(pMenus.length == 1)
            {
                cMenus = pMenus[0].children.filter(t=>t.name == 'JobAssign')
                if(cMenus.length == 1)
                {
                    var menu5 = {
                        path: "JobAssign_edit",
                        name: "JobAssign_edit",
                        label: "Job 指派",
                        icon: "s-home",
                        meta: {
                            istrun: true // 默认隐藏路由
                        },
                        url: "Setup_job/Assign_edit",
                    };
                    data.push(menu5);
                }
            }

 // 微信報表授權管理先從 proan_wechat.sub_company 選擇商家，再由伺服器使用該商家的 customer_dat
            // 讀取及保存授權資料。後端尚未建立選單資料時，在基本設定下補上前端路由。
            /*
            var baseMenu = data.find(t => t.label === '_base_setup' || t.label === '基本設定' || (t.label && t.label.indexOf('基本') !== -1));
            if (!baseMenu) {
                baseMenu = { path: 'base_setup', name: 'base_setup', label: '_base_setup', icon: 'setting', children: [] };
                data.push(baseMenu);
            }
            if (!baseMenu.children) baseMenu.children = [];
            if (!baseMenu.children.some(t => t.name === 'Wechat_report_auth')) {
                baseMenu.children.push({
                    path: 'Wechat_report_auth',
                    name: 'Wechat_report_auth',
                    label: '_wechat_report_auth',
                    icon: 'chat-dot-round',
                    url: 'Wechat_report_auth/Index',
                    acode: 'YSAED',
                });
            }
            */
            const addStorelletMenu = menus => {
                for (const menu of menus || []) {
                    if (menu.children) {
                        if (menu.children.some(child => child.name === 'MenuSyncLog' || child.url === 'Report/MenuSyncLog') && !menu.children.some(child => child.name === 'StorelletLog')) {
                            menu.children.push({ path: 'StorelletLog', name: 'StorelletLog', label: 'storellet日志', icon: 'menu', url: 'Report/StorelletLog' });
                        }
                        addStorelletMenu(menu.children);
                    }
                }
            };
            addStorelletMenu(data);
            resolve(data);
        });
    });
    return p
};
// 请求使用者名稱
export const Get_tb_user_name = (params) => {
    // 返回一个promise对象
    return http.get("/Cust_info/Get_tb_user_name", params);
};
// 请求報表
export const Get_sales_call_report = (params) => {
    // 返回一个promise对象
    return http.get("/Sales_call/Get_sales_call_report", params);
};
// 请求QrCode報表
export const Get_qrCode_report = (params) => {
    // 返回一个promise对象
    return http.get("/Cust_info/QrCode", params);
};
// 查詢QrCode商戶連綫狀態
export const Get_qrCode_connect = (params) => {
    // 返回一个promise对象
    return http.get("/Cust_info/QrCodeConnect", params);
}
// 查詢QrCode商戶斷線日志
export const Get_qrCode_disconlog = (params) => {
    // 返回一个promise对象
    return http.get("/Cust_info/QrCodeDisConnectLog", params);
}
// 查詢QrCode商戶斷線日志
export const Set_qrCode_endDate = (data) => {
    // 返回一个promise对象
    return http.post("/Cust_info/QrCodeEndDateSet", data);
}
// 商戶的Sales
export const Get_qrCode_Sales = (params) => {
    // 返回一个promise对象
    return http.get("/Cust_info/QrCodeSalesLst", params);
}


// 取同事每1日的遲到分鍾數 報表
export const Get_attendance_detail_report= (params) => {
    // 返回一个promise对象
    return http.get("/Cust_info/Get_attendance_detail_report", params);
};
//統計每個同事, 當月總遲到分鍾數
export const Get_attendance_report= (params) => {
    // 返回一个promise对象
    return http.get("/Cust_info/Get_attendance_report", params);
};
//僅取廣州同事
export const Get_sys_user_gz = (data) => {
    // 返回一个promise对象
    return http.get("/Cust_info/Get_sys_user_gz", data);
};
//保存考勤(設置遲到分鍾數等)
export const save_attendance = (data) => {
    // 返回一个promise对象
    return http.post("/Cust_info/save_attendance", data);
  };
// 判斷與公司的距離
export const Get_distance_from_company = (params) => {
    // 返回一个promise对象
    return http.get("/Cust_info/Get_distance_from_company", params);
};

export const Get_User_ForTrans = () => {
    return http.get("/ProanOrder/TransToUser");
};

// 線上訂單查詢：商家搜尋及指定日期的發票資料
export const Get_online_order_merchants = (params) => {
    return http.get("/ProanOrder/GetOnlineOrderMerchant", params);
};

export const Get_online_order_sections = (params) => {
    return http.get("/ProanOrder/GetOnlineOrderSections", params);
};

export const Get_online_order_payment_methods = (params) => {
    return http.get("/ProanOrder/GetOnlineOrderPaymentMethods", params);
};

export const Get_online_order_invoices = (params) => {
    return http.get("/ProanOrder/GetOnlineOrderInvoice", params);
};

export const Get_online_order_detail = (params) => {
    return http.get("/ProanOrder/GetOnlineOrderDetail", params);
};

export const Get_online_order_payment_logs = (params) => {
    return http.get("/ProanOrder/GetOnlineOrderPaymentLogs", params);
};

// 查詢指定商戶及日期的菜單同步日志
export const Get_menu_sync_logs = (params) => {
    return http.get("/ProanOrder/GetMenuSyncLogs", params);
};

export const Check_online_order_send = (data) => {
    return http.post("/ProanOrder/CheckOnlineOrderSend", data);
};

export const Refund_online_order = (data) => {
    return http.post("/ProanOrder/RefundOnlineOrder", data);
};

export const Get_storellet_logs = params => http.get("/ProanOrder/GetStorelletLogs", params);
